import { useKeyboardEvents } from 'dashboard/composables/useKeyboardEvents';
import { useAutazoEmbeddedAccess } from 'dashboard/integrations/autazo/useAutazoEmbeddedAccess';
import { useRoute, useRouter } from 'vue-router';

export function useSidebarKeyboardShortcuts(toggleShortcutModalFn) {
  const route = useRoute();
  const router = useRouter();
  const { canShowGlobalNavigation } = useAutazoEmbeddedAccess();

  const isCurrentRouteSameAsNavigation = routeName => {
    return route.name === routeName;
  };

  const navigateToRoute = (routeName, globalNavigation = false) => {
    // AUTAZO INTEGRATION: global shortcuts must not initiate hidden navigation.
    // See docs/autazo-integration/03-frontend-conversations-only.md.
    if (globalNavigation && !canShowGlobalNavigation.value) return;

    if (!isCurrentRouteSameAsNavigation(routeName)) {
      router.push({ name: routeName });
    }
  };
  const keyboardEvents = {
    '$mod+Slash': {
      action: () => toggleShortcutModalFn(true),
    },
    '$mod+Escape': {
      action: () => toggleShortcutModalFn(false),
    },
    'Alt+KeyC': {
      action: () => navigateToRoute('home'),
    },
    'Alt+KeyV': {
      action: () => navigateToRoute('contacts_dashboard', true),
    },
    'Alt+KeyR': {
      action: () => navigateToRoute('account_overview_reports', true),
    },
    'Alt+KeyS': {
      action: () => navigateToRoute('agent_list', true),
    },
  };

  return useKeyboardEvents(keyboardEvents);
}
